import { Link } from "react-router-dom";
import type { NewsItem } from "@/types";
import SectionHeading from "@/components/base/SectionHeading";
import NewsCard from "@/components/feature/NewsCard";
import { NewsCardSkeleton } from "@/components/base/Skeleton";

interface NewsZoneProps {
  news: NewsItem[];
  loading: boolean;
}

export default function NewsZone({ news, loading }: NewsZoneProps) {
  const ticker = news.slice(0, 6).map((n) => n.title);
  const top = news.slice(0, 3);

  return (
    <section className="w-full bg-background-50 border-y border-background-200">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <SectionHeading
          eyebrow="News Flash"
          title="新闻快讯"
          desc="滚动浏览最新体育新闻标题，点击进入完整报道。"
          action={
            <Link
              to="/news"
              className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
            >
              全部资讯 <i className="ri-arrow-right-line" />
            </Link>
          }
        />

        <div className="mb-8 flex items-center gap-3 rounded-lg border border-accent-200 bg-accent-50 px-4 py-3 overflow-hidden">
          <span className="shrink-0 flex items-center gap-1.5 text-xs font-label text-accent-700">
            <i className="ri-flashlight-fill" /> 快讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-marquee whitespace-nowrap">
              {[...ticker, ...ticker].map((t, i) => (
                <Link
                  key={`${t}-${i}`}
                  to={`/news/${news[i % news.length]?.id ?? ""}`}
                  className="mx-6 text-sm text-foreground-700 hover:text-accent-600 transition-colors"
                >
                  {t}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {Array.from({ length: 3 }).map((_, i) => (
              <NewsCardSkeleton key={i} />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {top.map((n) => (
              <NewsCard key={n.id} item={n} />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}